import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const priceStepperSection = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s12,
  },
]);

export const priceContainer = style([
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
    margin: `${space.s8}px auto ${space.s4}px`,
  },
]);

export const priceMain = style([typography.headlineSm]);

export const priceSubInfo = style([
  typography.bodyMd,
  {
    color: themeVars.color.text.tertiary,
  },
]);

export const discountSubInfo = style([
  typography.bodyMd,
  {
    display: 'flex',
    flexDirection: 'column',
  },
]);

export const discountThenPrice = style([
  typography.bodyMd,
  {
    color: themeVars.color.text.tertiary,
  },
]);
